if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.setupDrinkPicker();
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    setupDrinkPicker() {
      const original = this.form.querySelector('[data-martesana-drink]');
      if (!original || original.dataset.simplified) return;
      const groups = Array.from(original.querySelectorAll('optgroup')).map(group => ({
        title: group.label,
        variants: Array.from(group.querySelectorAll('option')).map(option => ({
          option,
          parts: option.dataset.title.slice(group.label.length).replace(/^\s*·\s*/, '').split(' / ').filter(Boolean)
        }))
      }));
      if (!groups.length) return;
      original.dataset.simplified = 'true';
      const host = original.parentElement;
      const controls = document.createElement('div');
      const beverage = document.createElement('select');
      beverage.className = original.className;
      beverage.id = original.id + '-beverage';
      beverage.add(new Option('Sin bebida', ''));
      groups.forEach((group, index) => {
        const option = new Option(group.title, String(index));
        option.disabled = group.variants.every(v => v.option.disabled);
        beverage.add(option);
      });
      host.before(controls);
      const label = this.form.querySelector('label[for="' + original.id + '"]');
      if (label) label.htmlFor = beverage.id;
      const wrapSelect = select => {
        const wrap = document.createElement('div');
        wrap.className = 'select';
        wrap.style.marginBottom = '12px';
        wrap.append(select);
        return wrap;
      };
      controls.append(wrapSelect(beverage));
      const details = document.createElement('div');
      controls.append(details);
      host.hidden = true;
      host.style.display = 'none';
      const render = () => {
        details.replaceChildren();
        original.value = '';
        if (beverage.value === '') return;
        const group = groups[Number(beverage.value)];
        const dimensions = Math.max(...group.variants.map(v => v.parts.length));
        const selects = [];
        const summary = document.createElement('p');
        summary.className = 'caption';
        summary.setAttribute('aria-live', 'polite');
        const sync = () => {
          const match = group.variants.find(v => !v.option.disabled && selects.every((select, i) => v.parts[i] === select.value));
          original.value = match ? match.option.value : '';
          summary.textContent = match ? match.option.textContent : 'Esta combinación está agotada. Elige otra opción.';
          selects.forEach((select, i) => {
            Array.from(select.options).forEach(option => {
              option.disabled = !group.variants.some(v => !v.option.disabled && v.parts[i] === option.value && selects.every((other, j) => j >= i || v.parts[j] === other.value));
            });
          });
        };
        for (let i = 0; i < dimensions; i++) {
          const select = document.createElement('select');
          select.className = original.className;
          select.id = beverage.id + '-' + i;
          const values = [...new Set(group.variants.map(v => v.parts[i]).filter(Boolean))];
          const title = document.createElement('label');
          title.className = 'form__label';
          title.htmlFor = select.id;
          title.textContent = values.some(v => /^(Frío|Caliente)$/.test(v)) ? 'Temperatura' : values.some(v => /leche|entera|deslactosada|avena|almendra|coco/i.test(v)) ? 'Tipo de leche' : 'Presentación o sabor';
          values.forEach(value => select.add(new Option(value.replace(/^Leche\s+(de\s+)?/i, ''), value)));
          selects.push(select);
          details.append(title, wrapSelect(select));
          select.addEventListener('change', () => {
            const available = group.variants.find(v => !v.option.disabled && selects.every((s, j) => j > i || v.parts[j] === s.value));
            if (available) selects.forEach((s, j) => { if (j > i) s.value = available.parts[j]; });
            sync();
          });
        }
        const first = group.variants.find(v => !v.option.disabled);
        if (first) selects.forEach((select, i) => { select.value = first.parts[i]; });
        details.append(summary);
        sync();
      };
      beverage.addEventListener('change', render);
      render();
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      let formData = new FormData(this.form);
      const extras = [
        { selector: '[data-martesana-side]', property: 'Acompañamiento' },
        { selector: '[data-martesana-drink]', property: 'Bebida' }
      ].map((extra) => {
        const select = this.form.querySelector(extra.selector);
        const option = select && select.selectedOptions[0];
        return { ...extra, select, option };
      }).filter((extra) => extra.option && extra.option.dataset.variant);
      if (extras.length) {
        const sandwichData = formData;
        const quantity = sandwichData.get('quantity') || '1';
        formData = new FormData();
        formData.append('items[0][id]', sandwichData.get('id'));
        formData.append('items[0][quantity]', quantity);
        for (const [key, value] of sandwichData.entries()) {
          const property = key.match(/^properties\[(.+)\]$/);
          if (property) formData.append('items[0][properties][' + property[1] + ']', value);
          if (key === 'selling_plan') formData.append('items[0][selling_plan]', value);
        }
        extras.forEach((extra, index) => {
          formData.append('items[0][properties][' + extra.property + ']', extra.option.dataset.title);
          formData.append('items[' + (index + 1) + '][id]', extra.option.dataset.variant);
          formData.append('items[' + (index + 1) + '][quantity]', quantity);
          formData.append('items[' + (index + 1) + '][properties][Para]', extra.select.dataset.sandwich);
        });
      }

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (response.items && response.items.length) response = { ...response.items[0], ...response };
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
